// Utility functions for managing loading documents state

export interface LoadingDocument {
  id: string;
  type: string;
  title: string;
}

const STORAGE_KEY = 'loading_documents';

export function addLoadingDocument(id: string, type: string, title: string) {
  try {
    const loadingDocs = getLoadingDocuments();
    const key = `${type}-${id}`;

    // Check if already loading
    if (!loadingDocs.some(doc => `${doc.type}-${doc.id}` === key)) {
      loadingDocs.push({ id, type, title });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(loadingDocs));
      window.dispatchEvent(new Event('loading-docs-updated'));
    }
  } catch (error) {
    console.error('Failed to add loading document:', error);
  }
}

export function removeLoadingDocument(id: string, type: string) {
  try {
    const loadingDocs = getLoadingDocuments();
    const key = `${type}-${id}`;
    const filtered = loadingDocs.filter(doc => `${doc.type}-${doc.id}` !== key);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    window.dispatchEvent(new Event('loading-docs-updated'));
  } catch (error) {
    console.error('Failed to remove loading document:', error);
  }
}

export function getLoadingDocuments(): LoadingDocument[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
    return [];
  } catch (error) {
    console.error('Failed to get loading documents:', error);
    return [];
  }
}

export function isDocumentLoading(id: string, type: string): boolean {
  const loadingDocs = getLoadingDocuments();
  const key = `${type}-${id}`;
  return loadingDocs.some(doc => `${doc.type}-${doc.id}` === key);
}

export function clearLoadingDocuments() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event('loading-docs-updated'));
  } catch (error) {
    console.error('Failed to clear loading documents:', error);
  }
}
